export default "__VITE_ASSET__BxH_L7g$__"